<template>
  <div>
    <div class="policyContent">
      <div class="head-box">
        <div class="head">
          <span class="title">可结算保单统计</span>
          <span class="content"><span style="color: red">*</span>以下统计数据为，截至今日0时是否满足结算条件的保单。最终结算与否，请以实际发放为准。</span>
        </div>
        <!-- <div class="right-box">
          <el-button class="back-btn" @click="back()">返回</el-button>
        </div> -->
      </div>
      <div class="satatistics">
        <img class="wenjianImg" src="@static/images/wenjian.png" alt />
        <div class="items">
          <div class="item">
            <span class="item-content">{{ totalData.balanceDate | formatDate('yyyy/MM/dd') }}</span>
            <span class="item-title">预计结算周期</span>
          </div>
          <div class="item">
            <span class="item-content">{{ totalData.incomesSum || 0 }}</span>
            <span class="item-title">预估可结算服务费(元)</span>
          </div>
          <div class="item">
            <span class="item-content">{{ totalData.policyNum || 0 }}</span>
            <span class="item-title">可结算保单(件)</span>
          </div>
          <div class="item">
            <span class="item-content">{{ totalData.unsettleablePolicyNum || 0 }}</span>
            <span class="item-title">不可结算保单(件)</span>
          </div>
        </div>
      </div>
      <div class="content-data">
        <!-- 搜索部分 -->
        <topSearchForm @search="searchAjax" @export="daochu">
          <el-form :inline="true" :model="searchParams" ref="loginform" label-width="80px">
            <el-form-item label="保单号">
              <el-input v-model="searchParams.policyNo" placeholder="请输入" clearable></el-input>
            </el-form-item>
            <el-form-item label="保单状态">
              <el-select v-model="searchParams.policyStatus" placeholder="请选择" clearable>
                <el-option label="保障中" value="1"></el-option>
                <el-option label="已退保" value="3"></el-option>
                <el-option label="已终止" value="4"></el-option>
                <el-option label="已失效" value="5"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="承保时间">
              <a-range-picker v-model="searchParams.dateTime" format="yyyy-MM-DD" valueFormat="yyyy-MM-DD" separator="至">
                <i class="icon-riqixuanze" slot="suffixIcon"></i>
              </a-range-picker>
            </el-form-item>

            <el-form-item label="产品名称">
              <el-input v-model="searchParams.productName" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </el-form>
        </topSearchForm>
        <el-tabs class="content" v-model="btn" type="border-card" @tab-click="changeList">
          <el-tab-pane label="可结算保单" name="1">
            <div class="table">
              <el-table border :data="tableData" class="list-table" tooltip-effect="dark" v-loading="listLoading">
                <el-table-column min-width="150px;" label="承保时间" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    {{ scope.row.issueTime | formatDate('yyyy/MM/dd') }}
                  </template>
                </el-table-column>
                <el-table-column label="保单号" min-width="200px;" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <div>{{ scope.row.policyNo ? scope.row.policyNo : '-' }}</div>
                  </template>
                </el-table-column>
                <el-table-column property="policyStatus" label="保单状态" min-width="120px;" :show-overflow-tooltip="true">
                  <template slot-scope="{ row }">
                    <div>{{ all.POLICY_STATUS[row.policyStatus] }}</div>
                  </template>
                </el-table-column>
                <el-table-column property="mechanShortName" label="出单机构" min-width="200px;" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="productName" label="产品名称" min-width="240px;" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="policyStatus" label="投/被保人" min-width="170px;" :show-overflow-tooltip="true">
                  <template slot-scope="{ row }">
                    {{ row.policyerName }}<span v-if="row.policyerName && row.insuranceName">/</span>{{ row.insuranceName }}
                  </template>
                </el-table-column>
                <el-table-column property="fee" label="保费(元)" min-width="170px;" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="incomes" label="预估服务费(元)" min-width="170px;" :show-overflow-tooltip="true"></el-table-column>
              </el-table>
              <el-pagination
                class="page"
                background
                v-if="pageFlag"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="allData.current"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="allData.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="allData.total"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="不可结算保单" name="2">
            <div class="table">
              <el-table border :data="tableData" class="list-table" tooltip-effect="dark" v-loading="listLoading">
                <el-table-column min-width="150px;" label="承保时间" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    {{ scope.row.issueTime | formatDate('yyyy/MM/dd') }}
                  </template>
                </el-table-column>
                <el-table-column label="保单号" min-width="200px;" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <div>{{ scope.row.policyNo ? scope.row.policyNo : '-' }}</div>
                  </template>
                </el-table-column>
                <el-table-column property="policyStatus" label="保单状态" min-width="120px" :show-overflow-tooltip="true">
                  <template slot-scope="{ row }">
                    <div>{{ all.POLICY_STATUS[row.policyStatus] }}</div>
                  </template>
                </el-table-column>
                <el-table-column property="mechanShortName" label="出单机构" min-width="200px;" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="productName" label="产品名称" min-width="240px;" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="policyStatus" label="投/被保人" min-width="170px;" :show-overflow-tooltip="true">
                  <template slot-scope="{ row }">
                    {{ row.policyerName }}<span v-if="row.policyerName && row.insuranceName">/</span>{{ row.insuranceName }}
                  </template>
                </el-table-column>
                <el-table-column property="fee" label="保费(元)" min-width="170px;" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="incomes" label="预估服务费(元)" min-width="170px;" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="不可结原因" min-width="270px;" fixed="right">
                  <template slot-scope="scope">
                    <div class="reason-wrap">
                      <div class="reason-box" v-for="(item, idx) in scope.row.unsettleableReasonList" :key="idx">
                        <span class="reason">{{ ++idx }}.{{ item.reason || '-' }}</span>
                        <span
                          v-if="item.url || item.urlType == 3"
                          @click="getUrl({ ...item, policyNo: scope.row.policyNo })"
                          :class="'btn-copy' + ' copy' + item.urlType"
                          >复制链接</span
                        >
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                class="page"
                background
                v-if="pageFlag"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="allData.current"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="allData.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="allData.total"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import topSearchForm from '@/components/topSearchForm.vue';
import { common, pageTool } from '@/api/mixins';
export default {
  components: {
    topSearchForm
  },
  mixins: [common, pageTool],
  data() {
    return {
      btn: '1',
      tableData: [],
      listLoading: false,
      pageFlag: false,
      pageNum: 1,
      pageSize: 10,
      totalData: {},
      all: {},
      allData: null // 列表所有数据
    };
  },
  mounted() {
    this.all = this.$tools.getLocal('all');
    window.scrollTo(0, 0);
    this.getList();
  },
  methods: {
    back() {
      history.go(-1);
    },
    //获取链接
    async getUrl(row) {
      let url = '';
      if (row.urlType == 3) {
        let res = await this.$http({
          url: '/master/policy/queryConfirmRightUrl',
          type: 'GET',
          params: {
            policyNo: row.policyNo
          }
        });
        console.log(res);
        url = res.data;
      } else {
        url = row.url;
      }
      console.log('url---', url);
      if (url) {
        const cInput = document.createElement('input');
        cInput.value = url;
        document.body.appendChild(cInput);
        cInput.select(); // 选取文本域内容;
        // 执行浏览器复制命令
        // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
        // Input要在正常的编辑状态下原生复制方法才会生效
        document.execCommand('Copy');
        this.$message({
          message: '获取成功',
          type: 'success'
        });
        /// 复制成功后再将构造的标签 移除
        cInput.remove();
      } else {
        this.$message.error('暂无链接可获取');
      }
    },
    changeList() {
      this.pageNum = '1';
      this.getList();
    },
    // 订单列表
    getList() {
      this.listLoading = true;
      let searchParams = JSON.parse(JSON.stringify(this.searchParams));
      if (searchParams.dateTime && searchParams.dateTime.length) {
        searchParams.issueTimeStart = searchParams.dateTime[0];
        searchParams.issueTimeEnd = searchParams.dateTime[1];
        delete searchParams.dateTime;
      }
      this.$http({
        url: '/master/policySettleable/queryData',
        type: 'PUT',
        params: {
          ...searchParams,
          type: this.btn,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
      }).then(res => {
        this.listLoading = false;
        this.tableData = res.data;
        this.totalData = res.settleableTotal;
        this.pageFlag = false;
        this.allData = res;
        if (this.allData.total != 0) {
          this.pageFlag = true;
        }
      });
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },

    handleCurrentChange(val) {
      this.pageNum = val;
      this.getList();
    },

    daochu() {
      const params = JSON.parse(JSON.stringify(this.searchParams));
      if (params.dateTime && params.dateTime.length) {
        params.issueTimeStart = params.dateTime[0];
        params.issueTimeEnd = params.dateTime[1];
        delete params.dateTime;
      }
      this.$tools.daochu('/master/policySettleable/exportData', params, 'PUT');
    }
  }
};
</script>

<style lang="scss" scoped>
.policyContent {
  min-height: 1080px;
  background: #fff;
  .head-box {
    padding: 20px 0 15px 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .head {
      .title {
        font-size: 20px;
        color: #333333;
      }
      .content {
        padding-left: 13px;
        font-size: 12px;
        color: #888888;
      }
    }
    .back-btn {
      border: 1px solid #f47900;
      color: #f47900;
      width: 80px;
      height: 32px;
    }
    .el-button {
      padding: 0;
    }
  }
  .satatistics {
    height: 88px;
    margin: 18px 30px 20px 30px;
    border-radius: 10px;
    background: linear-gradient(106deg, #fff7ea 0%, #fff1e8 100%);
    display: flex;
    align-items: center;
    .wenjianImg {
      height: 88px;
    }
    .items {
      display: flex;
      align-items: center;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 250px;
        &:not(:last-child) {
          border-right: 1px solid #e8d9c9;
        }
        .item-title {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          line-height: 20px;
          color: #6a5041;
        }
        .item-content {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 600;
          line-height: 22px;
          color: #fc7700;
        }
      }
    }
    .back-btn {
      width: 80px;
      height: 32px;
      border-radius: 4px;
      background: #f47900;
      color: #fff;
    }
    .el-button {
      padding: 0;
    }
  }
  .content-data {
    padding: 20px 30px;
    border-top: 1px solid #ececec;
    .btns {
      display: flex;
      .btn-item {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 124px;
        height: 30px;
        background: #f3f3f3;
        border-radius: 4px;
        color: #666666;
        margin-right: 15px;
        cursor: pointer;
        &.active {
          background: #f47900;
          color: #ffffff;
        }
      }
    }
    .table {
      margin-top: 15px;
      .reason-wrap {
        text-align: left;
        .reason-box {
          display: flex;
          margin: 4px 0;
          .reason {
            flex: 1;
          }
          .btn-copy {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #f47900;
            cursor: pointer;
            // flex: 1;
            text-align: right;
            white-space: nowrap;
            margin-right: 10px;
          }
          .disabled {
            cursor: none;
            color: #f3f3f3;
          }
        }
      }
      /deep/.cell {
        line-clamp: 10 !important;
        overflow: unset !important;
        -webkit-line-clamp: 10 !important;
      }
    }
  }
}
</style>